export const getAgencyInitials = (agencyName?: string) => {
  if (!agencyName) return 'UA'

  return agencyName
    .split(' ')
    .map((name) => name.charAt(0).toUpperCase())
    .slice(0, 2)
    .join('')
}
